var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-padding": "" } },
        [
          _c(
            "w-breadcrumb",
            { attrs: { crumbs: _vm.path } },
            [_c("w-spacer")],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c("app-price-rule-edit-list", {
                attrs: {
                  rules: _vm.rules,
                  "new-rule-constructor": _vm.newRuleConstructor,
                  "save-rule-function": _vm.saveRule,
                },
                on: {
                  "delete-rule": function ($event) {
                    return _vm.deleteRule($event)
                  },
                  sorted: function ($event) {
                    return _vm.onSorted()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }